
// @ts-nocheck
import locale_nb_46ts_648be509 from "#nuxt-i18n/648be509";
import locale_nn_46ts_6f635f31 from "#nuxt-i18n/6f635f31";

export const localeCodes =  [
  "nb",
  "nn"
]

export const localeLoaders = {
  nb: [
    {
      key: "locale_nb_46ts_648be509",
      load: () => Promise.resolve(locale_nb_46ts_648be509),
      cache: true
    }
  ],
  nn: [
    {
      key: "locale_nn_46ts_6f635f31",
      load: () => Promise.resolve(locale_nn_46ts_6f635f31),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/44b66854" /* webpackChunkName: "config_i18n_46config_46ts_44b66854" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "nb",
      name: "Bokmål",
      language: "nb-NO",
      _hreflang: "nb-NO",
      _sitemap: "nb-NO",
      files: [
        {
          path: "/builds/aschehoug/aschehoug-utdanning/vgs-app/i18n/locales/nb.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "nn",
      name: "Nynorsk",
      language: "nn-NO",
      _hreflang: "nn-NO",
      _sitemap: "nn-NO",
      files: [
        {
          path: "/builds/aschehoug/aschehoug-utdanning/vgs-app/i18n/locales/nn.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "nb",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "nb",
    name: "Bokmål",
    language: "nb-NO",
    _hreflang: "nb-NO",
    _sitemap: "nb-NO",
    files: [
      {
        path: "/builds/aschehoug/aschehoug-utdanning/vgs-app/i18n/locales/nb.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "nn",
    name: "Nynorsk",
    language: "nn-NO",
    _hreflang: "nn-NO",
    _sitemap: "nn-NO",
    files: [
      {
        path: "/builds/aschehoug/aschehoug-utdanning/vgs-app/i18n/locales/nn.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/